var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgArrowLeftCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.29 11.29a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l3 3a1.004 1.004 0 1 0 1.42-1.42L11.41 13H15a1 1 0 0 0 0-2h-3.59l1.3-1.29a1 1 0 0 0-.325-1.639 1 1 0 0 0-1.095.219l-3 3ZM2 12a10 10 0 1 0 20 0 10 10 0 0 0-20 0Zm18 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
  fill: "currentColor"
})));

export default SvgArrowLeftCircle;